import { post } from "../https";

const api = "/xywapi";
// 获取待点评/已点评 数量
export async function getUserJudgesData(data) {
  return await post(`${api}/userJudges/getUserJudgesData`, data);
}
// 获取 待点评/已点评 数据
export async function getPageJudgesWorks(data) {
  return await post(`${api}/userWorks/getPageJudgesWorks`, data);
}
// 获取热线/微信号
export async function getJudgesHotLine(data) {
  return await post(`${api}/param/getParam`, data);
}
// 获取作品详情
export async function getWorksByJudges(worksId) {
  return await post(`${api}/userWorks/getWorksByJudges/${worksId}`);
}
// 点评作品
export async function commentWorks(data) {
  return await post(`${api}/userWorks/commentWorks`, data);
}
// 加载专业组别
export async function getJudgesMajorAndGroup(data) {
  return await post(`${api}/swMajor/getJudgesMajorAndGroup`, data);
}
// 加载服务单位
export async function getInstitutionList(data) {
  return await post(`${api}/userWorks/getInstitutionList`, data);
}
// 评论记录
export async function getPageCommentRecord(data) {
  return await post(`${api}/userJudges/getPageCommentRecord`, data);
}
// 锁定作品
export async function lockCommentWorks(id) {
  return await post(`${api}/userWorks/lockCommentWorks/${id}`);
}
// 解锁作品
export async function unlockCommentWorks(id) {
  return await post(`${api}/userWorks/unlockCommentWorks/${id}`);
}
